import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  OffCanvasLayout,
  Table,
  ConfirmationBox,

} from "@wac-ui-dashboard/wac_component_library";
import EmptyData from "../../Global/EmptyData";
import useEnquiry from "./useEnquiry";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
const Enquiry = () => {
  const { mainData,
    menuState,
    isLoading,
    isFetching,
    handleDateChange,
    handleSearch,
    handleEditClick,
    handleDelete,
    handleSort,
    getRow,
    currentPage,
    paginationOptions,
    handlePagination,
    handlePageSize,
    showEditModal,
    closeEditModal,
    refetch,
    updateTableFeildsData,
    handleActionChange,
    actionOptions
  } = useEnquiry();

  return (
    <>
      <HeadingGroup
        title={"Enquiry"}
        className={`pro-mb-4`}
      // buttonTitle={"Add new"}
      // handleClick={handleCreateClick}
      />

      <div className={`col-auto pro-pt-3 pro-pb-6`}>
        <div className="row">
          <div className="col">
            <SearchFilters
              data={mainData?.data?.filters}
              onDateChange={handleDateChange}
              onSearchInput={handleSearch}
              showActions={false}
              handleActionClick={handleEditClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              actionOptions={actionOptions?.filter((item) => item.value === 0)}
              onActionOptionChange={handleActionChange}
              //showClearFilters
              // handleClear={handleClearClick}
              searchInputProps={{ value: menuState?.search }}

            />
          </div>
        </div>

        {mainData?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            data={mainData?.data?.data || []}
            uniqueID={"id"}
            clear={menuState.clearSelection}
            multiSelect={false}
            assignable={false}
            fields={mainData?.data?.fields}
            SortIcon={<FaSort />}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            perpage={menuState?.currentPageSize}
          />
        )}

        {mainData?.data?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            defaultValue={paginationOptions?.filter(
              (item) => item.value === menuState?.currentPageSize
            )}
            totalPageCount={mainData?.data?.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout show={showEditModal} handleClose={closeEditModal} backdrop="static">
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={Object.keys(mainData?.data?.fields ?? {})
                .reduce((filteredObj, property) => {
                  filteredObj[property] = mainData?.data?.fields[property];
                  return filteredObj;
                }, {})}
              moduleId={mainData?.data?.module_id}
              updateData={updateTableFeildsData}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  )
}

export default Enquiry
